import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BaseSaleOrderPreporties, SuppliersProperties, SuppliersListProperties, SupplierAccessCodeBaseData, AgencySupplierRightsdata, ViewAgencySupplierRightsData, SuppliersList } from '../Models/SuppliersProperties';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { SuppliersCurrency } from '../Models/OfflineBookingRequestProperties';


@Injectable({
  providedIn: 'root'
})

export class SuppliersService {
  baseUrl = environment.baseUrl;
  backSystemBaseUrl = environment.backSystemBaseUrl;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  GetSupplierCodeByID(param): Observable<SuppliersList[]> {
    return this.http.post<SuppliersList[]>(this.baseUrl + '/ERPBackOffice/GetSupplierCodes', param, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getSupplierAccessCodeBaseData(): Observable<SupplierAccessCodeBaseData> {
    return this.http.get<SupplierAccessCodeBaseData>(this.baseUrl + '/Suppliers/GetBaseDataAirSupplierAccessCode')
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }
  getSuppliersBackOffice(id): Observable<BaseSaleOrderPreporties> {
    return this.http.get<BaseSaleOrderPreporties>(this.backSystemBaseUrl + '/saleorder/GetServiceBaseData/' + id)
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }

  getSuppliersList(): Observable<SuppliersListProperties> {
    return this.http.get<SuppliersListProperties>(this.baseUrl + '/Suppliers/GetSuppliersList')
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }
  create(supplierObj): Observable<boolean> {
    this.showSpinner.next(true);

    return this.http.post<boolean>(this.baseUrl + '/Suppliers/addNewSupplier', supplierObj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  getSupplierAccessCodeById(code): Observable<SuppliersProperties> {
    return this.http.get<SuppliersProperties>(this.baseUrl + '/Suppliers/GetSupplierAccessCodeById/' + code)
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }
  update(supplierObj: SuppliersProperties): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/Suppliers/updateSupplier', supplierObj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  updateStatus(supplierObj): Observable<boolean> {
    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/Suppliers/updateStatus', supplierObj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  checkSupplierName(supplierObj: SuppliersProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Suppliers/CheckSupplierName', supplierObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  getSupplierById(id): Observable<SuppliersProperties> {
    return this.http.get<SuppliersProperties>(this.baseUrl + '/Suppliers/GetSupplierById/' + id)
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }

  CreateAgencySupplierRights(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Suppliers/CreateAgencySupplierRights', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  GetSuppliersByParent(param): Observable<AgencySupplierRightsdata> {
    return this.http.get<AgencySupplierRightsdata>(this.baseUrl + '/Suppliers/GetSuppliersByParent/' + param)
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }
  GetViewAgencySupplierRights(param): Observable<ViewAgencySupplierRightsData[]> {
    return this.http.get<ViewAgencySupplierRightsData[]>(this.baseUrl + '/Suppliers/GetViewAgencySupplierRights/' + param)
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }

  CheckSupplierManagementRight(userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Suppliers/CheckSupplierManagementRight/' + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }



  GetCompanyMaster(): Observable<CompanyMasterProperties[]> {
    return this.http.get<CompanyMasterProperties[]>(this.baseUrl + '/CompanyMaster/GetActiveCompanyMaster').pipe(map((data: CompanyMasterProperties[]) => {
      return data;
    }), catchError(error => { return throwError(error) }))
  }

  //20-jan-24
  GetSupplierCurrencies(): Observable<SuppliersCurrency[]> {
    return this.http.get<SuppliersCurrency[]>(this.baseUrl + '/OfflineBooking/SupplierCurrenciesGet').pipe(map((data: SuppliersCurrency[]) => {
      return data;
    }), catchError(error => { return throwError(error) }))
  }
  //end
  CreateAgencySupplier(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Suppliers/CreateAgencySuppliers', obj)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
}
